<script>
  import { createEventDispatcher, onDestroy } from "svelte";
  import Search from "../Search.svelte";
  import SectionNav from "../SectionNav.svelte";
  import LevelSelect from "../LevelSelect.svelte";
  import HamburgerIcon from "../icons/HamburgerIcon.svelte";
  import ActionsArea from "../ActionsArea.svelte";
  import FilterGroup from "./FilterGroup.svelte";
  import FilterCheckbox from "./FilterCheckbox.svelte";
  import FilterRange from "./FilterRange.svelte";
  import FilterUserArea from "./FilterUserArea.svelte";
  import { filterStateStore, sortStore } from "../stores.js";

  const dispatch = createEventDispatcher();

  function hideFilters() {
    document.body.style.overflow = "";
    filterStateStore.set({ active: false });
  }

  function handleLevelsChange(event) {
    dispatch("levelsChange", { levels: event.detail.levels });
  }

  const srsValues = ["Apprentice", "Guru", "Master", "Enlightened", "Burned"];
  const partsOfSpeech = [
    "noun",
    "intransitive verb",
    "godan verb",
    "transitive verb",
    "ichidan verb",
    "する verb",
    "の adjective",
    "い adjective",
    "な adjective",
    "other adjective",
    "suffix",
    "adverb",
    "proper noun",
    "expression",
    "numeral",
    "counter",
    "pronoun",
    "prefix",
    "interjection",
    "conjunction"
  ];
</script>

<style>
  #filters {
    background: var(--white);
    box-shadow: var(--card-box-shadow);
    overflow-y: scroll;
    position: fixed;
    margin-top: -2.5rem;
    padding-top: 2rem;
    max-height: 89vh;
    width: 23vw;
  }

  nav {
    align-items: center;
    display: flex;
    flex: 1;
    justify-content: flex-end;
  }

  .hamburger {
    position: absolute;
    left: 1rem;
    background: none;
    border: none;
    padding: 0;
  }

  .close {
    position: absolute;
    top: 1rem;
    right: 1rem;
    background: none;
    font-size: 1rem;
    color: #aaa;
    cursor: pointer;
    padding: 0;
    background: rgba(255, 255, 255, 1);
    border: none;
    opacity: 0;
    transition: opacity 0.5s;
    transition-delay: 0.4s;
  }

  .close.filters-active {
    opacity: 1;
  }

  @media screen and (max-width: 768px) {
    #filters {
      position: absolute;
      top: -4rem;
      width: 85vw;
    }

    .close {
      color: #888;
      font-size: 2.25rem;
      position: fixed;
      top: 0rem;
      right: 17%;
    }

    .filter-close-text {
      display: none;
    }
  }
</style>

<section id="filters">
  <FilterUserArea />
  <ActionsArea />
  <FilterGroup id="filter-search" dataTestId="filter-search">
    <Search />
  </FilterGroup>
  {#if $sortStore === 'frequently missed'}
    <FilterGroup
      id="filter-percentage-correct"
      dataTestId="filter-percentage-correct"
      collapseable={true}
      title="Max Percentage Correct">
      <FilterRange type="percentage-correct" />
    </FilterGroup>
  {/if}
  <FilterGroup
    id="filter-levels"
    dataTestId="filter-levels"
    collapseable={true}
    title="Levels">
    <LevelSelect on:levelsChange={handleLevelsChange} />
  </FilterGroup>
  <FilterGroup
    id="filter-subject"
    dataTestId="filter-subject"
    collapseable={true}
    title="Subject Type">
    <FilterCheckbox type="subjectType" value="radical" displayText="Radicals" />
    <FilterCheckbox type="subjectType" value="kanji" />
    <FilterCheckbox type="subjectType" value="vocabulary" />
  </FilterGroup>
  <FilterGroup
    id="filter-srs-level"
    dataTestId="filter-srs-level"
    collapseable={true}
    title="SRS Level">
    {#each srsValues as value}
      <FilterCheckbox type="srs" {value} />
    {/each}
  </FilterGroup>
  <FilterGroup
    id="filter-part-of-speech"
    dataTestId="filter-part-of-speech"
    collapseable={true}
    title="Parts of Speech">
    {#each partsOfSpeech as value}
      <FilterCheckbox type="partOfSpeech" {value} />
    {/each}
  </FilterGroup>
  <nav class:active={$filterStateStore.active}>
    <button
      class="close"
      class:filters-active={$filterStateStore.active}
      name="hide filters"
      on:click={hideFilters}>
      &times
      <span class="filter-close-text">Hide Filters</span>
    </button>
  </nav>
</section>
